import axios from '../../axios'

export const getMailings = () => {
  return axios.get('/mailing')
}

export const getMailing = (id) => {
  return axios.get('/mailing/' + id)
}

export const create = (data) => {
  return axios.post('/mailing', data)
}

export const update = (id, data) => {
  return axios.patch('/mailing/' + id, data)
}

export const attachment = (tenderId, attachment) => {
  return axios.post('/mailing/' + tenderId + '/attachment', attachment)
}



// WEBPACK FOOTER //
// ./src/api/production/mailing/index.js